var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSubmitFeedback(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 41L23 53L30 41L16 41Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 53L30 41L16 41L23 53ZM23 49.0307L26.5179 43L19.4821 43L23 49.0307Z",
    fill: "#546278"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 19C8 14.5817 11.5817 11 16 11H48C52.4183 11 56 14.5817 56 19V35C56 39.4183 52.4183 43 48 43H16C11.5817 43 8 39.4183 8 35V19Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48 13H16C12.6863 13 10 15.6863 10 19V35C10 38.3137 12.6863 41 16 41H48C51.3137 41 54 38.3137 54 35V19C54 15.6863 51.3137 13 48 13ZM16 11C11.5817 11 8 14.5817 8 19V35C8 39.4183 11.5817 43 16 43H48C52.4183 43 56 39.4183 56 35V19C56 14.5817 52.4183 11 48 11H16Z",
    fill: "#546278"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 25C15 24.4477 15.4477 24 16 24H32C32.5523 24 33 24.4477 33 25C33 25.5523 32.5523 26 32 26H16C15.4477 26 15 25.5523 15 25Z",
    fill: "#546278"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 19C15 18.4477 15.4477 18 16 18H38C38.5523 18 39 18.4477 39 19C39 19.5523 38.5523 20 38 20H16C15.4477 20 15 19.5523 15 19Z",
    fill: "#546278"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 31C15 30.4477 15.4477 30 16 30H38C38.5523 30 39 30.4477 39 31C39 31.5523 38.5523 32 38 32H16C15.4477 32 15 31.5523 15 31Z",
    fill: "#546278"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6789 50.7893L34.0166 52.4157L34.7756 47.5366L49.413 29.6464L53.4248 33.0076L38.6789 50.7893Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0165 53.5C33.7996 53.5 33.4744 53.3916 33.3659 53.2831C33.0407 53.0663 32.9322 52.6326 33.0407 52.3073L33.7996 47.4282C33.7996 47.2113 33.9081 47.1029 34.0165 46.886L48.5455 28.9958C48.7624 28.779 48.9792 28.5621 49.3045 28.5621C49.6298 28.5621 49.8466 28.6706 50.0635 28.779L54.0752 32.1402C54.5089 32.5739 54.6173 33.2244 54.1836 33.6581L39.5462 51.4399C39.4378 51.5483 39.2209 51.6568 39.1125 51.7652L34.4502 53.3916C34.2333 53.5 34.1249 53.5 34.0165 53.5ZM35.7513 47.9703L35.3176 50.7894L38.0282 49.8135L51.9067 33.116L49.5213 31.1643L35.7513 47.9703Z",
    fill: "#FF7920"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6074 24.7396L51.2625 27.5841L55.1945 30.8257L57.5395 27.9812L53.6074 24.7396Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2678 31.9233C55.051 31.9233 54.8341 31.8149 54.6173 31.7065L50.714 28.4537C50.4971 28.2369 50.3887 28.02 50.2803 27.6947C50.2803 27.3695 50.3887 27.1526 50.4971 26.9357L52.8825 24.1167C53.0993 23.8998 53.3162 23.7914 53.6415 23.683C53.9667 23.683 54.1836 23.7914 54.4004 23.8998L58.3038 27.1526C58.5206 27.3694 58.629 27.5863 58.7375 27.9116C58.7375 28.2369 58.629 28.4537 58.5206 28.6706L56.1353 31.4896C55.81 31.8149 55.4847 31.9233 55.2678 31.9233ZM52.7741 27.4779L55.051 29.3211L56.0268 28.1284L53.7499 26.2852L52.7741 27.4779Z",
    fill: "#FF7920"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmitFeedback);
export default __webpack_public_path__ + "static/media/submitFeedback.81383011b5e6291c916c5dce341300a8.svg";
export { ForwardRef as ReactComponent };